import {
  DRUPAL_NODE_DISPLAY,
  type DrupalImage,
  type DrupalNodePage,
  type DrupalTerm,
} from '@commons/types/drupal';

import CaseStudyNodeCard from './Card';
import CaseStudyNodeFeatured from './Featured';
import CaseStudyNodeFeaturedTile from './FeaturedTile';
import CaseStudyNodeLabel from './Label';
import CaseStudyNodeSmallCard from './SmallCard';
import CaseStudyNodeTeaser from './Teaser';

/**
 * Type definition of a CaseStudy node properties.
 */

export type CaseStudyNodeProps = DrupalNodePage & {
  date: string;
  image?: DrupalImage;
  format?: DrupalTerm;
  authors?: string;
  summary?: string;
};

/**
 * CaseStudy node component.
 *
 * Renders a component based on the display type.
 */

export const CaseStudyNode = (props: CaseStudyNodeProps) => {
  switch (props.display) {
    default:
    case DRUPAL_NODE_DISPLAY.Default:
    case DRUPAL_NODE_DISPLAY.Label:
      return <CaseStudyNodeLabel {...props} />;
    case DRUPAL_NODE_DISPLAY.Teaser:
      return <CaseStudyNodeTeaser {...props} />;
    case DRUPAL_NODE_DISPLAY.Card:
      return <CaseStudyNodeCard {...props} />;
    case DRUPAL_NODE_DISPLAY.SmallCard:
      return <CaseStudyNodeSmallCard {...props} />;
    case DRUPAL_NODE_DISPLAY.Featured:
      return <CaseStudyNodeFeatured {...props} />;
    case DRUPAL_NODE_DISPLAY.FeaturedTile:
      return <CaseStudyNodeFeaturedTile {...props} />;
  }
};

export default CaseStudyNode;
